const yesNo = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.ពិតមែន' }, { value: 2, text: '២.ទេ' }
]
const a1 = ['ឈ្មោះជាអក្សរខ្មែរ', 'ឈ្មោះជាអក្សរឡាតាំង (អក្សរពុម្ព)', 'អត្តលេខមន្ត្រីរាជការ', 'ថ្ងៃ ខែ ឆ្នាំកំណើត', 'ភេទ',
  'កម្រិតវប្បធម៌ខ្ពស់បំផុត', 'បើជានាយកជំនួស (សូមគូសរង្វង់)', 'សរុបចំនួនឆ្នាំបម្រើការងារអប់រំ', 'ចំនួនឆ្នាំបម្រើការងារជានាយក', 'ចំនួនម៉ោងបង្រៀនក្នុង១សប្ដាហ៍',
  'លេខទូរស័ព្ទរបស់នាយក/នាយិកា', 'សារអេឡិចត្រូនិច (E-mail)']
const a2 = ['ឈ្មោះសាលារៀន (បច្ចុប្បន្ន)', 'ឈ្មោះសាលារៀន (ឆ្នាំមុន)', 'ភូមិ', 'ឃុំ / សង្កាត់', 'ក្រុង / ស្រុក / ខណ្ឌ', 'រាជធានី / ខេត្ត ',
  'ទីតាំងសាលារៀន', 'បែបផែនទទួលថែកុមារ', 'សាលារៀនបណ្ដែតទឹក', 'សាលារៀនទាំងមូលនៅក្នុងវត្ត (សូមគូសរង្វង់)', 'ចំនួនថ្នាក់រៀននៅក្នុងវត្ត (បើមាន)',
  'សាលារៀនមត្តេយ្យស្ថិតនៅក្នុងសាលាបឋមសិក្សា']
const a3 = []
const pattern = [
  { value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.កន្លះថ្ងៃ' }, { value: 2, text: '២.ពេញ១ថ្ងៃ' },
  { value: 3, text: '៣.ពេញ១ថ្ងៃនិងអាហារថ្ងៃត្រង់' }
]
const preAge = ['<3', '3', '4', '5', '5+']
const preLevel = ['ថ្នាក់កម្រិតទាប', 'ថ្នាក់កម្រិតមធ្យម', 'ថ្នាក់កម្រិតខ្ពស់', 'ថ្នាក់ចម្រុះ', 'សរុប']
const b4 = ['ចំនួនកុមារដើមឆ្នាំសិក្សា', 'ចំនួនកុមារចុងឆ្នាំសិក្សា', 'ចំនួនកុមារអាយុ៥ឆ្នាំដែលឆ្លងកាត់តេស្តស្តង់ដាឆ្នាំសិក្សា',
  'ចំនួនកុមារអាយុ៥ឆ្នាំ បានបញ្ជូនទៅថ្នាក់ទី១ក្នុងឆ្នាំសិក្សាថ្មី']
const c2 = ['ឯកសារបង្រៀន', 'សម្ភារបង្រៀន', 'ល្បែងលេងក្នុងថ្នាក់']
const d2 = ['លេខាធិការ', 'ឆ្នាំសាលារៀន', 'បុគ្គលិកផ្សេងៗ', 'គ្រូទទួលបន្ទុកការងារសុខភាព']
const e4 = ['ទោងយោល', 'ក្ដាររំអិល', 'ក្ដារប៉ះប៉ើក', 'ផ្សេងៗ']

/* Configuration ON-OFF cells */
const lastStudentOnOff = [
  [1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1],
  [0, 0, 0, 0, 1, 1, 1, 1],
  [0, 0, 0, 0, 1, 1, 1, 1]
]
const preStudentOnOff = [
  [1, 1, 0, 0, 0, 0, 1, 1], // age <3
  [1, 1, 0, 0, 0, 0, 1, 1], // age = 3
  [0, 0, 1, 1, 0, 0, 1, 1],
  [0, 0, 0, 0, 1, 1, 1, 1],
  [0, 0, 0, 0, 0, 0, 1, 1]
]
/** Configuration of UI Page Text */
const priPreUIText = [
  ['១. អត្តសញ្ញាណ <p><br>និងព័ត៌មានសាវតា</p>', '<strong>១.(ក) នាយក/នាយិកាសាលាមត្តេយ្យសិក្សា</strong>', '<strong>១.(ខ) សាលាមត្តេយ្យសិក្សា</strong>'],
  ['២.សិស្សមត្តេយ្យសិក្សា', '២.(ក)សិស្សមត្តេយ្យសិក្សាតាមអាយុ និងតាមកម្រិតថ្នាក់ឆ្នាំសិក្សា',
    '២.(ខ)សិស្សមត្តេយ្យសិក្សាតាមអាយុនិងតាមកម្រិតថ្នាក់ដែលកំពុងរៀនសាលារដ្ឋ/សាលាផ្សេងទៀតក្នុងឆ្នាំសិក្សា',
    '២.(គ)សិស្សជួបការលំបាក និងសិស្សពិការតាមកម្រិតថ្នាក់',
    '២.(ឃ)សិស្សតាមអាយុ (ជនជាតិដើមភាគតិច) (ចំនួនសិស្សជនជាតិដើមភាគតិច ក្នុងចំណោមសិស្សសរុបទាំងអស់)', '២.(ង)ចំនួនសិស្សក្នុងឆ្នាំសិក្សា'],
  ['៣.បន្ទប់ សម្ភារសិក្សា<br>សម្ភារឧបទ្ទេស និងកម្មវិធីសិក្សា', '៣.(ក) បន្ទប់រៀន និងថ្នាក់រៀន', '៣.(ខ) ល្បែង និងសម្ភារសិក្សា', '៣.(គ) កម្មវិធីសិក្សា'],
  ['៤. បុគ្គលិកបង្រៀន <p><br>និងបុគ្គលិកមិនបង្រៀន</p>', '៤.(ក)ចំនួនបុគ្គលិកគិតតាមក្រុមអាយុ', ' ៤.(ខ)ចំនួនបុគ្គលិកគិតតាមឆ្នាំបម្រើការងារអប់រំ',
    '៤. (គ) កម្រិតវប្បធម៌របស់បុគ្គលិកក្របខ័ណ្ឌ និងវគ្គបណ្ដុះបណ្ដាលគរុកោសល្យ', '៤. (ឃ) ចំនួនបុគ្គលិកបង្រៀន/មិនបង្រៀនទទួលមុខងារបន្ថែម'],
  ['៥. អគារ និងបរិក្ខារ', '៥. (ក) ផ្ទៃដីសាលារៀន', '៥. (ខ) អំពីសំណង់', '៥. (គ) ស្ថានភាពអគារ បន្ទប់ និងបរិក្ខារ',
    '៥.(ឃ) ចំនួនបរិក្ខារ', '៥.(ង) សម្ភារល្បែងលេងក្រៅថ្នាក់', '៥.(ច) កន្លែងលាងដៃ',
    '៥.(ឆ) បង្គន់អនាម័យ (គិតជាបន្ទប់)', '៥.(ជ) ប្រភពទឹកសម្រាប់ប្រើប្រាស់', '៥.(ឈ) សម្ភារបរិក្ខារ'],
  ['៦.តម្លៃសិក្សាតាមកម្រិតថ្នាក់', '<strong>តម្លៃសិក្សាតាមកម្រិតថ្នាក់ (គិតក្នុង១ឆ្នាំសិក្សា)</strong>'],
  ['៧. ការចែកចាយថ្នាំព្រូន', '<strong>ការចែកចាយថ្នាំព្រូន</strong>']
]


export {
  pattern,
  a1, a2, a3,
  preAge, preLevel,
  b4, c2, d2, e4,
  yesNo,
  lastStudentOnOff, preStudentOnOff,
  priPreUIText
}
